import i18next from 'i18next';
import { tldExists } from 'tldjs';
import * as Yup from 'yup';

export const registrationPageOneValidationSchema = Yup.object().shape({
  Email: Yup.string()
    .required(i18next.t(`fields.errors.validation.emailRequired`))
    .email(i18next.t(`fields.errors.validation.emailFormat`))
    .matches(
      /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
      i18next.t(`fields.errors.validation.emailFormat`),
    )
    .max(50, i18next.t(`fields.errors.validation.emailMaxLength`))
    .test(
      'valid-tld',
      i18next.t(`fields.errors.validation.emailFormat`),
      (value) => !value || tldExists(value),
    ),
  Password: Yup.string()
    .required(i18next.t(`fields.errors.validation.password`))
    .max(50, i18next.t(`fields.errors.validation.passwordMaxLength`))
    .min(8, i18next.t(`fields.errors.validation.passwordInvalid`))
    .matches(
      /(?=.{8,50})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).*/,
      i18next.t(`fields.errors.validation.passwordInvalid`),
    ),
});
